export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9419.be61dcdc.jpg";